import { MessageCircle } from "lucide-react";
import { useWhatsAppNumber, buildWhatsAppLink } from "@/lib/api";
import { scrollToId } from "@/lib/scroll";

export default function FooterSection() {
  const year = new Date().getFullYear();
  const whatsapp = useWhatsAppNumber();

  return (
    <footer className="border-t border-white/10 bg-ink-deep px-5 sm:px-8 pt-14 pb-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <img src="/logo.png" alt="Logo Disciplina" data-testid="footer-logo" className="w-20 h-20 rounded-full ring-1 ring-white/10 mb-5" />
            <p className="font-display font-black text-3xl tracking-wide uppercase leading-none">
              Disciplina<span className="text-blood">Fit</span>
            </p>
            <p className="mt-3 text-neutral-400 text-sm max-w-xs leading-relaxed">
              Nessuna scusa. Solo disciplina, metodo e trasformazione reale.
            </p>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-blood font-semibold mb-4">Naviga</p>
            <ul className="space-y-2.5">
              {[["metodo", "Il Metodo"], ["bonus-excel", "Bonus Excel"], ["pacchetti", "Pacchetti"], ["faq", "FAQ"]].map(([id, label]) => (
                <li key={id}>
                  <button data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="text-neutral-300 hover:text-blood text-sm transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-blood font-semibold mb-4">Contatti</p>
            <a
              data-testid="footer-whatsapp-btn"
              href={buildWhatsAppLink(whatsapp, "Ciao! Voglio informazioni sui pacchetti DisciplinaFit.")}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-wa/50 text-wa hover:bg-wa/10 font-display font-bold uppercase tracking-wider px-6 py-2.5 transition-colors"
            >
              <MessageCircle size={16} /> Scrivimi su WhatsApp
            </a>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-wider text-neutral-500">Ordini e pagamenti concordati su WhatsApp</p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-neutral-500 text-xs">© {year} DisciplinaFit — Tutti i diritti riservati.</p>
          <p className="text-neutral-500 text-xs max-w-md sm:text-right">
            I contenuti hanno finalità di coaching sportivo e non sostituiscono il parere di un medico.
          </p>
        </div>
      </div>
    </footer>
  );
}
